import React, { useContext } from 'react';
import { CategoryList } from 'src/components/CategoryList/CategoryList';

import { HomeContext } from '../Home';

export default function CategoryListSection() {
    const { categories } = useContext(HomeContext);
    return <CategoryList categories={categories} />;
}
